import { useState } from "react";

import type { SignalType, SignalFilters } from "app/pages/sales-intelligence/domain/signals/types/signal";
import SignalTypesList from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalTypesList/SignalTypesList";
import SignalsList from "app/pages/sales-intelligence/sub-modules/signals/components/views/SignalsManagementView/SignalsList";
import { StyledContent } from "app/pages/sales-intelligence/sub-modules/signals/components/views/SignalsManagementView/styles";
import type SignalsManagementViewModel from "app/pages/sales-intelligence/sub-modules/signals/models/view/signals-management/SignalsManagementViewModel";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";

export type SignalManagementViewProps = {
    viewModel: Readonly<SignalsManagementViewModel>;
    initialSelectedType?: SignalType;
    onSignalCreate(signalType: SignalType): void;
    onSignalEdit<F extends SignalFilters>(signal: Readonly<UISignal<F>>): void;
    onSignalDelete<F extends SignalFilters>(signal: Readonly<UISignal<F>>): void;
    onSignalTypeSelect?(signalType: SignalType): void;
};

const SignalsManagementView = (props: SignalManagementViewProps) => {
    const { viewModel, initialSelectedType, onSignalCreate, onSignalDelete, onSignalEdit, onSignalTypeSelect } = props;

    const [selectedSignalType, selectSignalType] = useState(initialSelectedType ?? viewModel.initiallySelectedType);
    const signalsOfType = viewModel.getUISignalsOfType(selectedSignalType);

    function handleSignalTypeClick(signalType: SignalType) {
        if (selectedSignalType === signalType) {
            return;
        }

        selectSignalType(signalType);
        onSignalTypeSelect?.(signalType);
    }

    return (
        <StyledContent>
            <SignalTypesList
                selectedSignalType={selectedSignalType}
                signalTypes={viewModel.signalTypes}
                signalsCountPerType={viewModel.signalsCountPerType}
                onSignalTypeClick={handleSignalTypeClick}
            />
            <SignalsList
                signals={signalsOfType}
                selectedSignalType={selectedSignalType}
                onSignalCreate={onSignalCreate}
                onSignalEdit={onSignalEdit}
                onSignalDelete={onSignalDelete}
            />
        </StyledContent>
    );
};

export default SignalsManagementView;
